import { useEffect, useRef, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

/** Selo (e o que mais couber no canto) — a faixa mede `--canto-w` daqui. */
export function CantoDireito({ children }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const aplicar = () => {
      document.documentElement.style.setProperty(
        '--canto-w',
        `${Math.round(el.getBoundingClientRect().width)}px`
      );
    };
    aplicar();
    const ro = new ResizeObserver(aplicar);
    ro.observe(el);
    return () => {
      ro.disconnect();
      document.documentElement.style.setProperty('--canto-w', '0px');
    };
  }, []);
  return (
    <div className="canto-dir" ref={ref}>
      {children}
    </div>
  );
}
